/**
 * Compile-time literal union of all valid Communications field IDs.
 *
 * Derived from the field maps in `./communications-fields-*.ts`
 * (each wrapped in `defineFieldConfigMap`).
 * Used to narrow `SavedViewConfig.visibleColumns` so typos in saved views
 * are caught by `tsc`.
 */
import { coreCommunicationsFields } from "./communications-fields-core";
import { contactCommunicationsFields } from "./communications-fields-contact";
import {
  statusCommunicationsFields,
  metadataCommunicationsFields,
} from "./communications-fields-metadata";

export const COMMUNICATIONS_FIELDS = {
  ...coreCommunicationsFields,
  ...contactCommunicationsFields,
  ...statusCommunicationsFields,
  ...metadataCommunicationsFields,
};

/** Literal union of every valid communications field id. */
export type CommunicationsFieldId = keyof typeof COMMUNICATIONS_FIELDS;
